<template>
  <div
    class="row bg-white footer-bar items-center border"
  >
    <div class="col border-right text-center">
      <span class="label-key">Logado: </span>
      <TimerSeconds
        class="label-value"
        :value="agent.summary.loginSecs"
      />
    </div>

    <div class="col border-right text-center min-width-200">
      <span class="label-key">
        {{ totalAttendances === 1 ? 'Atendimento: ' : 'Atendimentos: ' }}
      </span>
      <span class="label-value font-weight-500"> {{ `( ${totalAttendances} )` || '-' }} </span>
      <TimerSeconds
        class="label-value"
        v-if="agent.inAttendance"
        :value="agent.summary.callSecs"
      />
      <TimerLabel
        class="label-value"
        v-else
        :seconds="agent.summary.callSecs"
      />
    </div>

    <div class="col border-right text-center">
      <span class="label-key">Pausa: </span>
      <TimerSeconds
        v-if="agent.paused"
        :value="agent.summary.pauseSecs"
        class="label-value"
      />
      <TimerLabel
        v-else
        :seconds="agent.summary.pauseSecs"
        class="label-value"
      />
    </div>

    <div class="col border-right text-center">
      <span class="label-key">TMO R: </span>
      <TimerLabel
        class="label-value"
        :seconds="averageReceptiveOperation"
      />
    </div>

    <div class="col text-center">
      <span class="label-key">TMO A: </span>
      <TimerLabel
        class="label-value"
        :seconds="averageActiveOperation"
      />
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import TimerLabel from '@/components/TimerLabel'
import TimerSeconds from '@/components/TimerSeconds'
import { DIRECTION_OUT } from '@/constants/directions'

export default {
  components: {
    TimerLabel,
    TimerSeconds
  },

  data () {
    return {
      window: {}
    }
  },

  computed: {
    ...mapState({
      current: (state) => state.attendanceModule.current,
      attendanceHistory: (state) => state.attendanceModule.history,
      agent: (state) => state.agentModule.session.agent,
      loading: (state) => state.agentModule.session.loading,
      agentModule: (state) => state.agentModule
    }),

    totalAttendances () {
      return Object.keys(this.attendanceHistory).length
    },

    averageActiveOperation () {
      return this.calculateAverageOperation((a) => a.direction === DIRECTION_OUT && a.hangupAt)
    },

    averageReceptiveOperation () {
      return this.calculateAverageOperation((a) => a.direction !== DIRECTION_OUT && a.hangupAt)
    }
  },

  methods: {
    calculateAverageOperation (filter) {
      const values = Object.values(this.attendanceHistory)
        .filter(filter)
      const total = values.reduce((a, b) => {
        return a + (b.hangupAt - b.createdAt)
      }, 0) / values.length

      return (total / 1000) || 0
    }
  }
}
</script>

<style lang="sass" scoped>
.label-value
  font-style: normal
  font-weight: normal
  font-size: 13px
  line-height: 15px
  color: #263238

.label-key
  font-style: normal
  font-weight: normal
  font-size: 12px
  line-height: 14px
  color: #263238
  opacity: 0.6

.border-right
  border-right: 1px solid #CFD8DC

.border
  border: 1px solid #CFD8DC

.footer-bar
  height: 32px

.min-width-200
  width: 200px !important
  min-width: 200px !important

.font-weight-500
  font-weight: 500
</style>
